import React from 'react';
import type { CreateFlow } from '@/utils/analytics-events';

/** Inline format icon (spec 2.4): a painted page with text lines, or a 3-panel grid with a speech bubble. */
export function FormatIcon({ format, className }: { format: CreateFlow; className?: string }) {
  const common = {
    viewBox: '0 0 48 48',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2.5,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    'aria-hidden': true as const,
    'data-format-icon': format,
    className,
  };
  if (format === 'picture-book') {
    return (
      <svg {...common}>
        <rect x="8" y="4" width="32" height="40" rx="3" />
        <rect x="13" y="9" width="22" height="16" rx="2" fill="currentColor" fillOpacity="0.25" />
        <path d="M13 31h22M13 36h22M13 41h14" />
      </svg>
    );
  }
  return (
    <svg {...common}>
      <rect x="4" y="5" width="40" height="38" rx="3" />
      <path d="M4 24h40M26 5v19M18 24v19" />
      <path d="M29 9h11v9h-5l-3 3v-3h-3z" fill="currentColor" fillOpacity="0.25" />
    </svg>
  );
}
